/**
 * admin/src/hooks/useStats.ts
 * Hook cho Overview stats
 */

import { useAdminData } from './useAdmin';
import type { AdminStats } from '../types/admin';

export function useStats() {
  const { data, isLoading, error, refetch } = useAdminData<AdminStats>('/stats');
  return { stats: data, isLoading, error, refetch };
}
